import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';

export const MILEAGE_TRACKER_VEHICLE_REDUCER_KEY = 'mileageTrackerVehicleStore';
export type MILEAGE_TRACKER_VEHICLE_REDUCER_KEY = typeof MILEAGE_TRACKER_VEHICLE_REDUCER_KEY;

export const MileageTrackerVehicleSchema = z.object({
  id: z.string().optional(),
  clientId: z.string().optional(),
  createdAt: z.string().optional(),
  modifiedAt: z.string().optional(),
  name: z.string(),
  make: z.string().optional(),
  model: z.string().optional(),
  year: z.number().int().optional(),
  isDefault: z.boolean().optional(),
  value: z.number().optional(),
  iconType: z.string().optional(),
  isDeleted: z.boolean().optional(),
  serviceStartOn: z.string().optional(),
});

export type MileageTrackerVehicleType = z.infer<typeof MileageTrackerVehicleSchema>;
export type MileageTrackerVehicleState = QcsResourceSlice<MileageTrackerVehicleType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [MILEAGE_TRACKER_VEHICLE_REDUCER_KEY]: MileageTrackerVehicleState;
  }
}
